import { render, staticRenderFns } from "./FormCanvas.vue?vue&type=template&id=1ffe7da2"
import script from "./FormCanvas.vue?vue&type=script&lang=js"
export * from "./FormCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports